const featuresPay = {
    featureTitle: 'ตัดสินใจทางธุรกิจจากข้อมูล',
    featureDescription:
        'รู้ว่าสินค้าใดขายดีที่สุดและสร้างกำไรสูงสุด พร้อมเข้าถึงรายงานทางการเงินได้ทุกที่ทุกเวลา ธุรกิจของคุณอยู่ในมือคุณ!',
    featureButton: "การสมัครพรีเมียม",
    featureStartingPrice: '80',
    featureEndingPart: '30',
    featureStaringText: 'เริ่มต้นที่',
    featureEndingText: 'พัน',

    features: [
        {
            title: 'สินค้าไม่จำกัด',
            description: 'เพิ่มสินค้าทั้งหมดที่คุณมีได้โดยไม่มีข้อจำกัด'
        },
        {
            title: 'พนักงานไม่จำกัด',
            description: 'เพิ่มพนักงาน/แอดมินให้กับธุรกิจได้โดยไม่มีข้อจำกัด'
        },
        {
            title: 'ประวัติไม่จำกัด',
            description: 'ดูการเปลี่ยนแปลงของบันทึกสต็อกย้อนหลังได้โดยไม่มีข้อจำกัด'
        },
        {
            title: 'ตัวกรองประวัติ',
            description: 'ดูประวัติตามประเภท หมวดหมู่ พนักงาน และวันที่ได้อย่างง่ายดาย'
        },
        {
            title: 'ดาวน์โหลดเป็น Excel',
            description: 'รับประวัติบันทึกสต็อกในรูปแบบ Microsoft Excel ได้ด้วยคลิกเดียว'
        },
        {
            title: 'ดาวน์โหลดเป็น PDF',
            description: 'รับรายการสินค้าและสต็อกล่าสุดในรูปแบบ PDF ได้ด้วยคลิกเดียว'
        }
    ],
    warehousesGuide: [
        {
            desc: 'สร้างคลังสินค้าหลายแห่งเพื่อการจัดการสต็อกที่ดียิ่งขึ้น'
        },
        {
            desc: 'กำหนดสินค้าให้กับสถานที่จัดเก็บเฉพาะ'
        },
        {
            desc: 'ติดตามระดับสินค้าคงคลังในแต่ละคลังสินค้า'
        }
    ],
    addVariantsGuide: [
        { desc: 'เพิ่มตัวเลือกสินค้า เช่น ขนาด สี หรือวัสดุ' },
        { desc: 'กำหนดระดับสต็อกสำหรับแต่ละตัวเลือก' },
        { desc: 'ติดตามสต็อกในแต่ละคลังสินค้า' }
    ]
}
export default featuresPay